import {
  OffenseValues,
  affectedParties,
  emotions,
  languages,
  otherEvidence,
  physicalEffects,
  relationships,
} from '@/models/domestic.incident.report';

export const languagesList = languages.map((language) => ({
  value: language,
  label: language,
}));

export const relationshipsList = Object.entries(relationships).map(
  ([value, label]) => ({
    value,
    label,
  }),
);

export const emotionsList = Object.entries(emotions).map(([value, label]) => ({
  value,
  label,
}));

export const affectedPartiesList = Object.entries(affectedParties).map(
  ([value, label]) => ({ value, label }),
);

export const otherEvidenceList = Object.entries(otherEvidence).map(
  ([value, label]) => ({ value, label }),
);

export const physicalEffectsList = Object.entries(physicalEffects).map(
  ([value, label]) => ({ value, label }),
);

export const commonOffensesList = OffenseValues.map((offense) => ({
  value: offense,
  label: offense,
}));
